const EDITABLE_DETAILS_FIELDS = Object.freeze({
  loadType: 'loadTypeId',
  refNumber: 'refNumber',
  notes: 'notes',
  customFields: 'customFields',
  eta: 'eta',
  carrier: 'userId'
});

export default EDITABLE_DETAILS_FIELDS;
